<template>
<w-sliding-popup :type="slidingPopupType" ref="slidingPopup" title="수집 설정 관리" width="1200" :default-content="false" @close="closePopup">
  <div class="body-content" slot="content" style="height:100%;">
    <w-rsc-getdata-type-setting style="float:left; width:calc(50% - 7.5px); height:100%;" ref="rscGetdataTypeSetting" @select-rsc-getdata-type="selectRscGetdataType" :rsc-getmethod-id="rscGetmethodId"></w-rsc-getdata-type-setting>
    <w-rsc-getdata-source-setting style="float:right; width:calc(50% - 7.5px); height:100%;" ref="rscGetdataSourceSetting" :selected-rsc-getdata-type="selectedRscGetdataType" :sliding-popup-type="slidingPopupType"></w-rsc-getdata-source-setting>
  </div>
</w-sliding-popup>
</template>

<script>
import WRscGetdataTypeSetting from './RscGetdataTypeSetting';
import WRscGetdataSourceSetting from './RscGetdataSourceSetting';

export default {
  name: 'WRscGetdataSettingPopup',
  components: {
    WRscGetdataTypeSetting,
    WRscGetdataSourceSetting,
  },
  props: {
    slidingPopupType: {
      type: String,
    },
    rscGetmethodId: {
      type: String,
    },
  },
  data() {
    return {
      selectedRscGetdataType: null,
    };
  },
  // mounted() {
  //   this.loadData();
  // },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
      if (this.$refs.rscGetdataTypeSetting) {
        this.loadData();
      } else {
        this.$nextTick(() => {
          this.loadData();
        });
      }
    },
    closePopup() {
      this.$emit('reload-rsc-get-method-data');
    },
    loadData() {
      if (this.$refs.rscGetdataTypeSetting) {
        this.$refs.rscGetdataTypeSetting.clear();
        this.$refs.rscGetdataSourceSetting.clear();
        this.$refs.rscGetdataTypeSetting.loadData();
      } else {
        this.$nextTick(() => {
          this.$refs.rscGetdataTypeSetting.loadData();
        });
      }
    },
    selectRscGetdataType(rscGetdataType) {
      this.selectedRscGetdataType = rscGetdataType;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/RscGetdataSettingPopup.vue